// extracted by mini-css-extract-plugin
export default {"fullscreen":"spinner_fullscreen__eXrQf","loader":"spinner_loader__zyGzH","l20-1":"spinner_l20-1__h1MwF","l20-2":"spinner_l20-2__4haEP","small":"spinner_small__D3AmF"};